import { FC } from 'react';

import { PageMetadata } from '@/shared/components/metadata';

const Metadata: FC = () => <PageMetadata description='This experience is not supported in the current environment.' segments={['Not Supported']} />;

export default Metadata;
